import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { Props } from '@/components/worker/WorkerListTable';

import { Theme } from '@/styles/Theme';

export const Container = styled.div<{ width: string }>`
  width: ${({ width }) => width};

  display: flex;
  flex-direction: column;
  gap: 0.625rem;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.625rem;
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const TableWrapper = styled.div<Pick<Props, 'width' | 'height'>>`
  position: relative;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  overflow-x: auto;
  overflow-y: auto;

  border: 0.0625rem solid ${Theme.colors.G_3};
  background-color: ${Theme.colors.WHITE};
`;

export const Table = styled.table<{ isDetailOrEditPage?: boolean }>`
  width: 100%;
  min-width: ${({ isDetailOrEditPage }) => (isDetailOrEditPage ? '800px' : '2400px')};
  table-layout: auto;
  border-spacing: 0;
  border-collapse: separate;

  thead {
    position: sticky;
    top: 0;
    z-index: 10;

    height: 3.75rem;
    background-color: ${Theme.colors.WHITE};

    font-size: 1rem;
    font-weight: bold;
    color: ${Theme.colors.BLACK};

    tr {
      th {
        border-bottom: 0.125rem solid ${Theme.colors.G_5};
      }
    }

    th:last-child {
      ${({ isDetailOrEditPage }) =>
        !isDetailOrEditPage &&
        css`
          position: sticky;
          right: 0;
          background-color: ${Theme.colors.WHITE};
          z-index: 11;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 0.0625rem;
            background-color: ${Theme.colors.G_3};
          }
        `}
    }
  }

  tbody {
    tr {
      height: 3.75rem;

      background-color: ${Theme.colors.WHITE};

      :hover {
        background-color: ${Theme.colors.G_7};
      }
    }
    td {
      border-bottom: 0.0625rem solid ${Theme.colors.G_5};

      text-align: center;
      vertical-align: middle;

      svg {
        display: inline-block;
      }
    }

    td:last-child {
      ${({ isDetailOrEditPage }) =>
        !isDetailOrEditPage &&
        css`
          position: sticky;
          right: 0;
          background-color: ${Theme.colors.WHITE};
          z-index: 5;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 0.0625rem;
            background-color: ${Theme.colors.G_3};
          }
        `}
    }

    tr:hover td:last-child {
      ${({ isDetailOrEditPage }) =>
        !isDetailOrEditPage &&
        css`
          background-color: ${Theme.colors.G_7};
        `}
    }
  }
`;

export const NoDataText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  text-align: center;
`;

export const StyledTr = styled.tr<{ isActive: boolean }>`
  ${({ isActive }) =>
    isActive &&
    css`
      td {
        color: ${Theme.colors.G_3};
      }
    `}
`;

export const PhoneCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const WarningWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: help;

  &:hover::after {
    content: '작업자의 연락처를 업데이트해주세요.';
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 0.5rem;
    padding: 0.5rem 0.75rem;
    background-color: ${Theme.colors.BLACK};
    color: ${Theme.colors.WHITE};
    font-size: 0.875rem;
    white-space: nowrap;
    border-radius: 0.25rem;
    z-index: 1000;
    pointer-events: none;
  }

  &:hover::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(0.25rem);
    margin-bottom: 0.25rem;
    border: 0.375rem solid transparent;
    border-top-color: ${Theme.colors.BLACK};
    z-index: 1000;
    pointer-events: none;
  }
`;
